import { VioletFrameWrapper } from './VioletFrame.styled';

export interface VioletFrameProps {
    children: React.ReactNode;
    paddingVariant?: 'primary' | 'secondary';
}

export const VioletFrame = ({
    children,
    paddingVariant = 'primary',
}: VioletFrameProps) => (
    <VioletFrameWrapper paddingVariant={paddingVariant}>
        {children}
    </VioletFrameWrapper>
);
